import { createFileRoute } from '@tanstack/react-router';

import { LabsScreen } from '../../features/labs/labs-screen';

/**
 * `/mylab/labs` — S18 Labs (E14 §2)
 *
 * 라우트는 얇게 둔다: 화면은 `features/labs`에 있다. 게이트는 부모 `mylab.tsx`가 맡는다.
 * 선택한 그룹은 `group` search param에 실어 뒤로 가기로 복원되게 한다(S18 §4).
 */
interface LabsSearch {
  group?: string;
}

export const Route = createFileRoute('/mylab/labs')({
  validateSearch: (search: Record<string, unknown>): LabsSearch => ({
    group: typeof search.group === 'string' ? search.group : undefined,
  }),
  component: LabsRoute,
});

function LabsRoute() {
  const { group } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <LabsScreen
      selectedGroupId={group}
      onSelectGroup={(groupId) => navigate({ search: { group: groupId } })}
    />
  );
}
